import { Search } from 'lucide-react';

import { AccountMenu, type AccountMenuProps } from './AccountMenu';

type TopBarProps = AccountMenuProps & {
  query: string;
  onQueryChange(query: string): void;
  onHome(): void;
};

export function TopBar({ query, onQueryChange, onHome, ...account }: TopBarProps) {
  return (
    <header className="topbar">
      <button type="button" className="brand" onClick={onHome}>
        Cloud<span>Sound</span>
      </button>

      <label className="topbar-search">
        <Search size={15} aria-hidden="true" />
        <input
          type="text"
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="Search sets, artists, genres"
          aria-label="Search sets"
        />
      </label>

      <span className="topbar-spacer" />
      <AccountMenu {...account} />
    </header>
  );
}
